import { COMPANY } from "../data/content";

export default function FloatingCTA() {
  const ctaButtons = [
    {
      id: "phone",
      label: `Ring / SMS: ${COMPANY.phone}`,
      href: `tel:${COMPANY.phoneRaw}`,
      icon: "fa-solid fa-phone",
      bgClass: "bg-emerald-600 hover:bg-emerald-500 text-white shadow-emerald-900/30 border-emerald-400/30",
      ariaLabel: `Ring til Hoofcare på ${COMPANY.phone}`,
    },
    {
      id: "email",
      label: "Send en e-mail",
      href: `mailto:${COMPANY.email}`,
      icon: "fa-solid fa-envelope",
      bgClass: "bg-forest-800 hover:bg-forest-700 text-sand-100 shadow-forest-950/40 border-forest-600/40",
      ariaLabel: `Send en e-mail til ${COMPANY.email}`,
    },
    {
      id: "facebook",
      label: "Følg os på Facebook",
      href: COMPANY.facebook,
      target: "_blank",
      rel: "noopener noreferrer",
      icon: "fa-brands fa-facebook-f",
      bgClass: "bg-[#1877F2] hover:bg-[#166fe5] text-white shadow-blue-950/30 border-white/20",
      ariaLabel: "Besøg vores Facebook-side",
    },
  ];

  return (
    <aside
      aria-label="Hurtig kontakt og sociale medier"
      className="fixed bottom-5 right-4 sm:bottom-8 sm:right-6 z-50 flex flex-col gap-3 items-end pointer-events-none"
    >
      {ctaButtons.map((btn) => (
        <div key={btn.id} className="relative flex items-center group pointer-events-auto">
          {/* Tooltip Label */}
          <span
            className="absolute right-14 sm:right-16 whitespace-nowrap px-3 py-1.5 rounded-lg bg-forest-950/90 text-sand-100 text-xs font-medium shadow-md border border-forest-800/80 opacity-0 group-hover:opacity-100 transition-all duration-300 ease-out translate-x-2 group-hover:translate-x-0 pointer-events-none"
          >
            {btn.label}
          </span>

          {/* Floating Icon Button */}
          <a
            href={btn.href}
            target={btn.target}
            rel={btn.rel}
            aria-label={btn.ariaLabel}
            title={btn.label}
            className={`w-12 h-12 sm:w-13 sm:h-13 rounded-full flex items-center justify-center border shadow-lg backdrop-blur-sm transition-all duration-300 ease-out transform group-hover:scale-110 active:scale-95 ${btn.bgClass}`}
          >
            <i className={`${btn.icon} text-lg sm:text-xl transition-transform duration-300 group-hover:rotate-6`} aria-hidden="true" />
          </a>
        </div>
      ))}
    </aside>
  );
}
